export const getWeekDays = (language, version = 'long') => {
  const date = new Date('2019');
  date.setDate(date.getDate() - date.getDay());
  const weekDays = [];

  for (let i = 0; i < 7; i++) {
    weekDays.push(date.toLocaleString(language, { weekday: version }));

    date.setDate(date.getDate() + 1);
  }

  return weekDays;
};

export default getWeekDays;
